module.exports = __webpack_public_path__ + "static/media/Back.cef997c5.svg";